import type { AnyGameModule } from '../core/contracts'
import type { TKey } from '../platform/i18n/i18nContext'

/**
 * Мост между контрактом ядра и словарём переводов.
 *
 * core/contracts объявляет titleKey как обычную строку - иначе ядро
 * зависело бы от platform/i18n, а этого мы не хотим. Плата за это -
 * каст на стороне UI. Собран сюда, чтобы «as TKey» встречался
 * ровно один раз, а не в каждом экране.
 */

type T = (key: TKey, params?: Record<string, string | number>) => string

export function gameTitle(t: T, game: AnyGameModule): string {
  return t(game.titleKey as TKey)
}

export function gameHint(t: T, game: AnyGameModule): string {
  return t(game.hintKey as TKey)
}

export function disciplineName(t: T, game: AnyGameModule): string {
  return t(`discipline.${game.discipline}` as TKey)
}
